"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CppObject = void 0;

var CppObject = /*#__PURE__*/function () {
  function CppObject(ptr, inst) {
    _classCallCheck(this, CppObject);

    this.ptr = ptr;
    this.inst = inst;
  }

  _createClass(CppObject, [{
    key: "checkAlive",
    value: function checkAlive() {
      if (this.ptr) return;
      throw Error('Call after destroyed');
    }
  }, {
    key: "getPointer",
    value: function getPointer() {
      this.checkAlive();
      return this.ptr;
    }
  }]);

  return CppObject;
}();

exports.CppObject = CppObject;